import { Link as RouterLink, Outlet } from "react-router-dom";

// Token-driven shell for unauthenticated / public pages (Guide, Privacy, Terms,
// Support). Reuses the kt-* black-bar logo; authenticated pages use <AppShell>.
export function PublicLayout() {
  return (
    <div className="kt-public">
      <header className="kt-public-bar">
        <RouterLink to="/login" className="kt-logo" aria-label="Aeronet Brain" style={{ textDecoration: "none" }}>
          <span className="kt-logo-dots" aria-hidden="true"><span /><span /><span /></span>
          <span className="kt-wordmark"><span className="kt-wm-aero">aero</span><span className="kt-wm-net">net</span></span>
          <span className="kt-brain-tag">brain</span>
        </RouterLink>
        <div style={{ flex: 1 }} />
        <RouterLink to="/guide" className="kt-cmd-pill" style={{ textDecoration: "none" }}>Guide</RouterLink>
        <RouterLink to="/login" className="kt-btn kt-btn--primary" style={{ textDecoration: "none" }}>Log in</RouterLink>
      </header>

      <main className="kt-public-main">
        <Outlet />
      </main>

      <footer className="kt-public-foot">
        <RouterLink to="/privacy">Privacy</RouterLink>
        <RouterLink to="/terms">Terms</RouterLink>
        <a href="mailto:hello@example.com">Contact</a>
      </footer>
    </div>
  );
}
